import { cn } from '@sohanemon/utils';
import type { ComponentProps } from 'react';

import { ThemedLottie } from './themed-lottie';

const ASTRONAUT_READING_COLOR_SLOTS = {
	'astronaut-ink': '--primary',
	'astronaut-primary': '--background',
	'astronaut-suit': '--card',
	'astronaut-white': '--card',
	'astronaut-shade': '--muted',
	'astronaut-accent': '--accent',
};

type AstronautReadingLottieProps = ComponentProps<typeof ThemedLottie>;

export function AstronautReadingLottie(props: AstronautReadingLottieProps) {
	const { autoplay = true, loop = true, className, style, ...rest } = props;

	return (
		<ThemedLottie
			src="/lottie/astronaut-reading.lottie"
			loop={loop}
			autoplay={autoplay}
			colorSlotTokens={ASTRONAUT_READING_COLOR_SLOTS}
			className={cn('mx-auto aspect-square w-full max-w-xl', className)}
			style={style}
			{...rest}
		/>
	);
}
